import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "base-checkbox" }
const _hoisted_2 = ["name"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "base-checkbox__check" }, null, -1)
const _hoisted_4 = { class: "base-checkbox__label" }

import { useVModel } from '@vueuse/core';

interface Props {
	name?: string;
	modelValue: boolean;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    name: null,
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'update:modelValue', v: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	name?: string;
	modelValue: boolean;
}





const checked = useVModel(props, 'modelValue', emit);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(checked) ? (checked).value = $event : null)),
      name: __props.name,
      type: "checkbox",
      class: "base-checkbox__input"
    }, null, 8, _hoisted_2), [
      [_vModelCheckbox, _unref(checked)]
    ]),
    _hoisted_3,
    _createElementVNode("span", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})